<template>
	<div>
		<a-table  size="small" :columns="columns" :data-source="list" bordered :loading="loading"
					   rowKey="id" :pagination="false" :scroll="{y:500}">
		</a-table>
	</div>
</template>

<script>
	const  columns=[
		{
			title: '小区名称',
			dataIndex: 'neighborname',
			width:150
		},
		{
		    title: '客户名称',
		   dataIndex:'customersname',
		   width:110
		},
		{
		    title: '电话',
		   dataIndex:'customersphone',
		   width:120,
		},
		{
		    title: '发送时间',
		   dataIndex:'date',
		   width:130,
		},
	];
	export default{
		props:['taskId','neighborId'],
		data(){
			return{
				columns,
				list:[],
				loading:true,
			}
		},
		methods:{
			queryDataList:function(){
				let url = this.Api.getLastUrl(this.Api.SCANNING_TASK_SMS_LOGS_URL);
				let param = {taskId:this.taskId,neighborId:this.neighborId};
				this.Api.fetchPostWithForm(url,param).then((data)=>{
					this.loading = false;
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.list = result;
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					this.loading = false;
					console.log(error);
				});
			},
		},
		created() {
			this.queryDataList();
		}
	}
</script>

<style>
</style>
